import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyACq3_gZgVeJnqkdUAsc3fjZmsmgSTwDRk",
  authDomain: "solar-products-manager.firebaseapp.com",
  projectId: "solar-products-manager",
  storageBucket: "solar-products-manager.appspot.com", // ✅ FIXED
  messagingSenderId: "454204065939",
  appId: "1:454204065939:web:d45aaae6e87bab10b42566",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
